<template>
  <div class="choose-state">
    <div v-for="(choose,index) in chooses " :key="choose.name" @click="active(index)">
      <img :src="index==inde?imgUrl2:imgUrl1" alt />
      <span :class="index==inde?'choosed':''" v-text="choose.name"></span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imgUrl1: require("@/assets/dataQuery/dp-ld-an1.png"),
      imgUrl2: require("@/assets/dataQuery/dp-ld-an2.png"),
      inde: 0
    };
  },
  methods: {
    active(index) {
      this.inde = index;
      this.$parent.choosed = index+1
      this.$parent.getMsg();
    }
  },
  name: "chooseState",
  props:{
    chooses:Array
  }
};
</script>
<style lang='scss' scoped>
.choose-state {
  div {
    .choosed {
      color: #fff;
    }
    span {
      position: absolute;
      top: 22%;
      width: 100%;
      left: 0;
      color: #999999;
    }
    img {
      width: 100%;
    }
    position: relative;
  }
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(3rem, 1fr));
  grid-template-rows: auto 1fr;
  text-align: center;
  padding: 0.3rem;
  background: #fff;
  box-shadow: 0px .06rem .06rem 0px rgba(0, 0, 0, 0.06);
}
</style>